import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import IntegrationControls from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/teletel-integrations'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'teletel_integration_controls',
          meta: { permissions: ['administrator'] },
          component: IntegrationControls,
        },
      ],
    },
  ],
};
